import React, { useState, useEffect } from 'react';

import { ContentBox } from '../ContentBox';
import { setVal2Token, getUserInfoCompanyId, getval2Token } from '../../../Login/Auth';
import { WageType_Arr } from '../../../../item/ItemCustomerPosition';
import { getItemsInfo, uuid } from '../../../../item/ItemTools';
import { CancelButton, SearchButton, SingleLink } from '../../Res/BaseButton';
import moment from 'moment';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput, SingleSelect } from '../../Res/BaseInput';
import { Pagination } from '../../Res/Pagination';
import { AutoSelect } from '../../Res/AutoSelect';
import { api_getSkill } from '../../../../api/apiResume';
import { ReqRecruitmentContractorStatusList, getCaseStatus, getCaseStatus_String } from '../../../../item/ItemRecruitmentContractorStatus';
import { api_getRecruitmentContractorStatusList } from '../../../../api/apiRecruitmentContractorStatus';
import { ReqRecruitmentContractorCaseInfo, CASE_STATUS_START, JOB_STATUS_ALL, JOB_STATUS_ALL_STRING, JOB_STATUS_RESTART, JOB_STATUS_RESTART_STRING, JOB_STATUS_RESERVE, JOB_STATUS_RESERVE_STRING, JOB_STATUS_ONBOARD, JOB_STATUS_ONBOARD_STRING, JOB_STATUS_NOT_ONBOARD, JOB_STATUS_NAT_ONBOARD_STRING } from '../../../../item/ItemRecruitmentContractor';

export function RecruitmentContractorStatusList({ id, setIsLoading, OnBoard, isEdit, isML = false, isAll = false }) {
    const [tokenId, setTokenId] = useState("")

    const [companyId] = useState(getUserInfoCompanyId())
    const [positionDemandList, setRecruitmentContractorStatusList] = useState([])

    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    const [mReqRecruitmentContractorStatusList, setReqRecruitmentContractorStatusList] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqRecruitmentContractorStatusList = new ReqRecruitmentContractorStatusList({ companyId, start, limit, contractorJobStatus: isAll ? JOB_STATUS_ALL : JOB_STATUS_NOT_ONBOARD })
            if (url === "") {
                toSearchInit({ items: mReqRecruitmentContractorStatusList, page: url.page })
            } else {
                mReqRecruitmentContractorStatusList.fromJson(url)
                // console.log(mReqRecruitmentContractorStatusList)
                setReqRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList)
                toSearchInit({ items: mReqRecruitmentContractorStatusList, page: url.page })
            }
        }
    }, [id])
    // useEffect(() => {
    //     if (positionDemandList.length === 0) {
    //         toSearch({ page: 1 })
    //     }
    // }, [])


    function toSearchInit({ items, page = 1 }) {
        var start = (page - 1) * limit;
        setPage(page)
        var mReqRecruitmentContractorStatusList = new ReqRecruitmentContractorStatusList({ companyId, start, limit })
        if (items !== undefined)
            mReqRecruitmentContractorStatusList.fromJson(items)
        mReqRecruitmentContractorStatusList.page = page
        setVal2Token("url", mReqRecruitmentContractorStatusList, id)
        setReqRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList)
        getRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList)
    }

    function toSearchFromPage({page = 1}){
        var start = (page - 1) * limit;
        setPage(page)
        var url = getval2Token("url", id)
        var mReqRecruitmentContractorStatusList = new ReqRecruitmentContractorStatusList({ companyId, start, limit })
        mReqRecruitmentContractorStatusList.fromJson(url)
        console.log(mReqRecruitmentContractorStatusList)
        mReqRecruitmentContractorStatusList.page = page
        setVal2Token("url", mReqRecruitmentContractorStatusList, id)
        setReqRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList)
        getRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList)
    }

    function getRecruitmentContractorStatusList(mReqRecruitmentContractorStatusList) {
        // console.log(mReqRecruitmentContractorStatusList)
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqRecruitmentContractorStatusList)
        api_getRecruitmentContractorStatusList({
            mReqRecruitmentContractorStatusList,
            success: (obj) => {
                console.log(obj)
                setRecruitmentContractorStatusList(obj.list)
                setCount(obj.count)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/CustomerPositionAdd/");
    }

    var title = '外派員工 最近一次 工作狀態列表'
    var content =
        <>
            {/* <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"職缺總數"} count={count} />
                </div>
            </div>
            <Space /> */}
            <RecruitmentContractorStatusListBox list={positionDemandList} srl={setRecruitmentContractorStatusList} count={count} page={page} sp={toSearchFromPage} isML={isML} isAll={isAll} />
        </>
    return (
        <>
            <RecruitmentContractorStatusListSearch action={toSearchInit} item={mReqRecruitmentContractorStatusList} isAll={isAll} />
            <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
            <SystemPromptInput />
        </>
    )
}

function RecruitmentContractorStatusListSearch({ action, item, isAll }) {
    const [mItem, setItem] = useState(null)
    const [name, setName] = useState("")
    const [address, setAddress] = useState("")
    const [jobStatus, setJobStatus] = useState(isAll ? JOB_STATUS_ALL : JOB_STATUS_NOT_ONBOARD)
    const [job, setJob] = useState("")
    const [office, setOffice] = useState("")
    const [skill, setSkill] = useState("")

    const [skillList, setSkillList] = useState([])

    useEffect(() => {
        // console.log(item)
        if (item !== undefined && mItem !== item) {
            setName(item.name || "")
            setAddress(item.address || "")
            // console.log(item.contractorJobStatus)
            setJobStatus(item.contractorJobStatus || (isAll ? JOB_STATUS_ALL : JOB_STATUS_NOT_ONBOARD))
            setJob(item.job || "")
            setOffice(item.office || "")
            setSkill(item.skill || "")
            setItem(item)
        }
    }, [item])

    useEffect(() => {
        getSkillList()
    }, [])

    function getSkillList() {
        api_getSkill({
            success: (result) => {
                setSkillList(result.list)
            },
            failure: (err) => {

            }
        })
    }

    function toClear() {
        setName("")
        setAddress("")
        setJobStatus(isAll ? JOB_STATUS_ALL : JOB_STATUS_NOT_ONBOARD)
        setJob("")
        setOffice("")
        setSkill("")
    }

    function toSearch() {
        var mReqRecruitmentContractorStatusList = new ReqRecruitmentContractorStatusList({
            name,
            address,
            contractorJobStatus: jobStatus,
            job,
            office,
            skill
        })
        // console.log(mReqRecruitmentContractorStatusList)
        action({ items: mReqRecruitmentContractorStatusList })
    }

    var jobStatusAttr = [
        { "val": JOB_STATUS_NOT_ONBOARD, "name": JOB_STATUS_NAT_ONBOARD_STRING },
        { "val": JOB_STATUS_RESTART, "name": JOB_STATUS_RESTART_STRING },
        { "val": JOB_STATUS_RESERVE, "name": JOB_STATUS_RESERVE_STRING },
    ]
    if (isAll) {
        jobStatusAttr = [
            { "val": JOB_STATUS_ALL, "name": JOB_STATUS_ALL_STRING },
            { "val": JOB_STATUS_RESTART, "name": JOB_STATUS_RESTART_STRING },
            { "val": JOB_STATUS_RESERVE, "name": JOB_STATUS_RESERVE_STRING },
            { "val": JOB_STATUS_ONBOARD, "name": JOB_STATUS_ONBOARD_STRING }
        ]
    }
    var content =
        <>
            <div className="row">
                <SingleInput title={"以姓名搜尋"} val={name} action={setName} size={4} />
                <SingleInput title={"以通訊地址搜尋"} val={address} action={setAddress} size={4} />
                <SingleSelect title={"工作狀態"}
                    val={jobStatus}
                    attr={jobStatusAttr}
                    action={setJobStatus}
                    size={4}
                />
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <SingleInput title={"以職缺名稱搜尋"} val={job} action={setJob} size={4} />
                <SingleInput title={"以廠商名稱搜尋"} val={office} action={setOffice} size={4} />
                <AutoSelect
                    title={"以專長搜尋"}
                    attr={skillList}
                    val={skill}
                    v={'skillId'}
                    n={'skillName'}
                    action={setSkill}
                    size={4}
                />
            </div>


            <div className="row m-t-sm m-t-sm">
                <div className="col-sm-4 col-sm-offset-5">
                    <CancelButton name={"清除"} action={toClear} />
                    <SearchButton action={toSearch} />
                </div>
            </div>

        </>
    return (
        <ContentBox hasTitle={false} content={content} hasDrawer={false} />
    )
}

function RecruitmentContractorStatusListBox({ list, srl, count, page, sp, isML, isAll }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<RecruitmentContractorStatusBox key={list[i].resumeId} item={list[i]} isML={isML} isAll={isAll} />)
            } else {
                itemList.push(<RecruitmentContractorStatusBox key={"resumeId" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-2">姓名</th>
                                    <th className="text-center sorting col-sm-1">年齡</th>
                                    <th className="text-center sorting col-sm-1">性別</th>
                                    <th className="text-center sorting col-sm-3">廠商</th>
                                    <th className="text-center sorting col-sm-3">職缺訊息</th>
                                    <th className="text-center sorting col-sm-1">狀態日期</th>
                                    <th className="text-center sorting col-sm-1">工作狀態</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function RecruitmentContractorStatusBox({ item, isML, isAll }) {
    const [mItem, setItem] = useState({})
    const [companyId] = useState(getUserInfoCompanyId())
    const [resumeId, setResumeId] = useState("")

    const [name, setName] = useState("")
    const [age, setAge] = useState("")
    const [sex, setSex] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [job, setJob] = useState("")
    const [shift, setShift] = useState("")
    const [wageType, setWageType] = useState("")

    const [jobInfo, setJobInfo] = useState("")

    const [statusDate, setStatusDeta] = useState("")
    const [status, setStatus] = useState("")


    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            setResumeId(item.resumeId)
            setItem(item)
            setName(item.name)
            const startDate = moment(item.birthday);
            const endDate = moment(new Date());
            const age = endDate.diff(startDate, 'years');
            setAge(age)
            setSex(item.sex === "1" ? "男" : item.sex === "2" ? "女" : "")

            if (item.job) {
                // setJobInfo(

                // <a href="#A" onClick={e => toDetail()}>
                //     {job}
                //     {item !== undefined ? "/" : <></>}
                //     {shift}
                //     {item !== undefined ? "/" : <></>}
                //     {getItemsInfo({ items: WageType_Arr, val: wageType })}
                // </a>)
            }

            setCompanyName(item.companyName)
            setJob(item.job)
            setShift(item.shift)
            setWageType(item.wageType)
            var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
            mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
            // console.log(mReqRecruitmentContractorCaseInfo)
            setCompanyName(mReqRecruitmentContractorCaseInfo.caseCompanyName)
            setJobInfo(mReqRecruitmentContractorCaseInfo.caseCustomerPosition)
            try {
                setStatus(getCaseStatus_String(item.caseStatus))
            } catch (error) {
                setStatus(item.contractorJobStatusDescription||'新人')
            }
            setStatusDeta(moment(item.contractorJobStatusCreatAt===''?item.creatAt:item.contractorJobStatusCreatAt).format('YYYY/MM/DD'))
            // var cs = getCaseStatus(item, mReqRecruitmentContractorCaseInfo)
            // switch (item.caseStatus) {
            //     case CASE_STATUS_START:
            //         setCompanyName(cs.companyName)
            //         setJobInfo(cs.jobInfo)
            //         setStatusDeta(cs.statusDeta)
            //         setStatus(cs.status)
            //         break;
            //     default:
            //         setStatusDeta(cs.statusDeta)
            //         setStatus(cs.status)
            //         break;
            // }
        }
    }, [item])

    // function toDetail() {
    //     var tokenId = uuid(128, 64)
    //     setVal2Token("resumeId", resumeId, tokenId)
    //     setVal2Token("item", JSON.stringify(item), tokenId)
    //     window.open("/RecruitmentContractorStatusDetail/" + tokenId, "_blank");
    // }

    function toIsOrNotOnboardSOP() {
        var tokenId = uuid(128, 64)
        setVal2Token("resumeId", resumeId, tokenId)
        window.open("/IsOrNotOnboardSOP/" + tokenId, "_blank");
    }

    return (
        <tr role="row">
            <td className="text-center">
                <SingleLink link={"RecruitmentContractorStatusDetail" + (isML ? "_ML" : isAll ? "_All" : "")}
                    name={name}
                    Key={"recruitmentContractorStatus"}
                    val={{ resumeId, item }} >
                </SingleLink>
            </td>
            {/* <td className="text-center"><a href="#A" onClick={e => toDetail()}>{name}</a></td> */}
            <td className="text-center">{age}</td>
            <td className="text-center">{sex}</td>
            <td className="text-center">{companyName}</td>
            <td className="text-center">{jobInfo}&nbsp;</td>
            <td className="text-center">{statusDate}</td>
            <td className="text-center text-info">{status}</td>
        </tr>
    )
}
